import { Dispatch, Action } from 'redux';
export const LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';

export const GET_DATA_USER_LOGIN_AUTH = 'GET_DATA_USER_LOGIN_AUTH';
export const VALIDATE_USER_AUTH = 'VALIDATE_USER_AUTH';

export const VALIDATE_TOKEN_REQUEST = 'VALIDATE_TOKEN_REQUEST';
export const VALIDATE_TOKEN_SUCCESS = 'VALIDATE_TOKEN_SUCCESS';
export const VALIDATE_TOKEN_FAILURE = 'VALIDATE_TOKEN_FAILURE';

export interface LoginUserRequestAction extends Action {
    type: typeof LOGIN_USER_REQUEST;
  }
  
  export interface LoginUserSuccessAction extends Action {
    type: typeof LOGIN_USER_SUCCESS;
    payload: any;
  }
  
  export interface LoginUserFailureAction extends Action {
    type: typeof LOGIN_USER_FAILURE;
    payload: string;
  }
  
  export type LoginActionTypes =
    | LoginUserRequestAction
    | LoginUserSuccessAction
    | LoginUserFailureAction;